module.exports = {
      id: "login-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#login",
      toString: function () {
        return this.url;
      }
    }